export default "__VITE_ASSET__D49Zi2LJ__"